module.exports = __webpack_public_path__ + "img/slide2.3ee14d67.png";